export type Reason = {
  id: string
  title: string
  description: string
}

export const reasons: Reason[] = [
  {
    id: 'r1',
    title: 'Quality First',
    description:
      'We focus on doing the job right—not simply getting it done.',
  },
  {
    id: 'r2',
    title: 'Attention to Detail',
    description:
      'From preparation to the final finish, every detail matters.',
  },
  {
    id: 'r3',
    title: 'Reliable Service',
    description:
      'Clear communication, professional service, and respect for your home.',
  },
  {
    id: 'r4',
    title: 'Built Around Your Vision',
    description:
      'Your home is unique. Every project should be designed around your goals.',
  },
  {
    id: 'r5',
    title: 'Professional Results',
    description:
      'Work that looks great today and continues to look great for years.',
  },
]

export type ProcessStep = {
  number: string
  title: string
  description: string
}

export const processSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Tell Us Your Vision',
    description: 'Contact us and tell us what you want to change.',
  },
  {
    number: '02',
    title: 'Get Your Estimate',
    description: "We'll discuss the project and provide an estimate.",
  },
  {
    number: '03',
    title: 'We Get to Work',
    description:
      'Our team handles the project with care and professionalism.',
  },
  {
    number: '04',
    title: 'Enjoy the Transformation',
    description: 'Step back and enjoy your newly improved home.',
  },
]
